export const StaffAccessPasses = {
  en: {
    'Scanning Devices': 'Scanning Devices',
    'Staff Passes': 'Staff Passes',
    'Create Staff Pass': 'Create Staff Pass',
    Label: 'Label',
    Location: 'Location',
    Token: 'Token',
    'Enter label': 'Enter label',
    Print: 'Print',
    'Delete failed': 'Delete failed',
  },
  uk: {
    'Scanning Devices': 'Скануючі пристрої',
    'Staff Passes': 'Перепустки персоналу',
    'Create Staff Pass': 'Створити перепустку',
    Label: 'Назва',
    Location: 'Локація',
    Token: 'Токен',
    'Enter label': 'Введіть назву',
    Print: 'Друк',
    'Delete failed': 'Не вдалося видалити',
  },
};
